import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("circle", { key: '0', fill: '#FF6565', cx: '12', cy: '12', r: '12' }),
    React.createElement("text", { key: '1', fill: '#FFFFFF', x: '12', y: '15', textAnchor: 'middle', fontSize: '8', fontWeight: '600', fontFamily: '"Roboto", sans-serif' }, "2216"),
], 'TransportActivity2216Icon');
const TransportActivity2216Icon = function (props) {
    return (React.createElement(SvgIcon, Object.assign({ className: '', sx: (theme) => ({
            circle: {
                fill: theme.palette[props.color].main,
            },
        }) }, props)));
};
export default memo(TransportActivity2216Icon);
